import React, { useState, useEffect, useRef } from 'react';

const TermAutocomplete = ({ value, termsList, onUpdate, disabled, style, placeholder, isTextArea, insertField = 'description', onSelectFullItem, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filteredOptions = termsList.filter(item => {
        const term = (value || '').toLowerCase();
        if (!term) return false;
        
        const searchString = `${item.code || ''} ${item.description || ''} ${item[insertField] || ''}`.toLowerCase();
        return searchString.includes(term);
    }).slice(0, 50);

    useEffect(() => {
        setSelectedIndex(-1);
    }, [value, isOpen]);

    const handleKeyDown = (e) => {
        if (!isOpen || filteredOptions.length === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setSelectedIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : 0));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelectedIndex(prev => (prev > 0 ? prev - 1 : filteredOptions.length - 1));
        } else if (e.key === 'Enter') {
            if (selectedIndex >= 0 && selectedIndex < filteredOptions.length) {
                e.preventDefault();
                handleSelect(filteredOptions[selectedIndex]);
            }
        }
    };

    const handleSelect = (item) => {
        let value;
        if (insertField === 'full') {
            value = item.code ? `${item.code}: ${item.description}` : item.description;
        } else {
            value = item[insertField] || item.description;
        }
        onUpdate(value.toUpperCase());
        if (onSelectFullItem) {
            onSelectFullItem(item);
        }
        setIsOpen(false);
    };

    const { openUp, listStyle: customListStyle } = props || {};

    return (
        <div ref={wrapperRef} style={{ position: 'relative', width: '100%', height: '100%' }}>
            {isTextArea ? (
                <textarea
                    style={{ ...style, resize: 'none' }}
                    value={value || ''}
                    onChange={(e) => {
                        onUpdate(e.target.value.toUpperCase());
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            ) : (
                <input
                    type="text"
                    style={{ ...style }}
                    className="form-control form-control-sm"
                    value={value || ''}
                    onChange={(e) => {
                        onUpdate(e.target.value.toUpperCase());
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            )}
            
            {isOpen && !disabled && value && filteredOptions.length > 0 && (
                <ul style={{
                    position: 'absolute',
                    ...(openUp ? { bottom: '100%', top: 'auto', marginBottom: '4px' } : { top: '100%', left: 0 }),
                    minWidth: '400px',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    zIndex: 9999,
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    textAlign: 'left',
                    ...customListStyle
                }}>
                    {filteredOptions.map((item, index) => (
                        <li 
                            key={item.id || item.code || Math.random()}
                            style={{ 
                                padding: '8px', 
                                cursor: 'pointer', 
                                borderBottom: '1px solid #eee', 
                                fontSize: '12px', 
                                fontFamily: 'Arial', 
                                lineHeight: '1.2',
                                backgroundColor: index === selectedIndex ? '#f0f0f0' : 'transparent'
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                handleSelect(item);
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f0f0f0';
                                setSelectedIndex(index);
                            }}
                            onMouseLeave={(e) => e.target.style.backgroundColor = index === selectedIndex ? '#f0f0f0' : 'transparent'}
                        >
                            {item.code && <strong style={{ color: '#b87a00', display: 'block', marginBottom: '2px' }}>{item.code}</strong>}
                            <span style={{ color: '#555' }}>
                                {(() => {
                                    const displayText = item.description || item[insertField] || '';
                                    return displayText.length > 150 ? displayText.substring(0, 150) + '...' : displayText;
                                })()}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TermAutocomplete;
